






















































// Importing functions
import {checkSession} from '@/ts/helpers';
import {postLogout} from '@/ts/auth/post-logout';

export default {
    name: 'BaseNavigation',
    components: {},
    props: {
        background: {
            type: String,
            default: 'default',
        },
    },
    data() {
        return {
            showAuth: false,
            username: '',
        };
    },
    methods: {
        logout() {
            // Logging out user
            postLogout().finally(() => {
                this.$router.push('/');
            });
        },
    },
    computed: {
        color() {
            return String(this.background) === 'default' ? 'color: white;' : 'color: black;';
        },
    },
    mounted() {
        // Getting username and id from the local storage
        this.username = localStorage.getItem('user');
        // Checking if the user is logged because the navigation component
        // is used in pages that do no require authentication.
        this.showAuth = checkSession();
    },
};
